import commonMutations from '@/store/data/common/mutations'
import Vue from 'vue'

const mutations = {
    setIsProcessing(state, { isProcessing }) {
        Vue.set(state, 'isProcessing', isProcessing)
    },

    setSharedAudiences(state, { items }) {
        Vue.set(state, 'list', items)
    },

    /**
     * Updates store sharing status for selected audience Id and sharedAccountId
     * @param {string} audienceId id of the audience to be retrieved
     * @param {string} partnerAccountId id of the partner to stop the sharing with
     */
    setSharedAccountStatus(state, { audienceId, sharedAccountId }) {
        state.list[audienceId] = state.list[audienceId].map(item => {
            if (parseInt(item.id) === parseInt(sharedAccountId)) {
                item.status = item.status === 'active' ? 'inactive' : 'active'
            }
            return item
        })
    }
}

export default { ...commonMutations, ...mutations }
